import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lightbulb"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.9998 0.999879C15.9698 1.0019 19.1998 4.23028 19.1998 8.19988C19.1998 9.28948 18.9833 10.1185 18.4926 11.3071C18.0019 12.4956 16.7461 15.0037 16.0039 16.9999H7.99609C7.28648 14.9986 6.00366 12.4962 5.5086 11.3071C5.01355 10.1179 4.7998 9.28948 4.7998 8.19988C4.7998 4.23028 8.02981 0.997856 11.9998 0.999879Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.5 20H15.5M10.5 23H13.5M11.9998 0.999879C15.9698 1.0019 19.1998 4.23028 19.1998 8.19988C19.1998 9.28948 18.9833 10.1185 18.4926 11.3071C18.0019 12.4956 16.7461 15.0037 16.0039 16.9999H7.99609C7.28648 14.9986 6.00366 12.4962 5.5086 11.3071C5.01355 10.1179 4.7998 9.28948 4.7998 8.19988C4.7998 4.23028 8.02981 0.997856 11.9998 0.999879Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Lightbulb = Vue.extend<IconProps>({
  name: 'LightbulbIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'lightbulb',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Lightbulb;
